// mainRouter.js


export default function MainRouter(props){
    return (
        <>
        </>
    )
}